import { render } from "./EditUserDashboard.vue?vue&type=template&id=8bf6c298&scoped=true"
import script from "./EditUserDashboard.vue?vue&type=script&lang=js"
export * from "./EditUserDashboard.vue?vue&type=script&lang=js"

import "./EditUserDashboard.vue?vue&type=style&index=0&id=8bf6c298&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bf6c298"]])

export default __exports__